const DEFAULT_DOMAIN = 'transastra.com';

/**
 * Allowed sign-in email domain. Override with REACT_APP_ALLOWED_EMAIL_DOMAIN.
 */
export function getAllowedEmailDomain() {
  const fromEnv = process.env.REACT_APP_ALLOWED_EMAIL_DOMAIN?.trim();
  if (fromEnv) {
    return fromEnv.toLowerCase().replace(/^@/, '');
  }
  return DEFAULT_DOMAIN;
}

export function isEmailDomainAllowed(email) {
  if (!email?.trim()) {
    return false;
  }
  const domain = getAllowedEmailDomain();
  const at = email.lastIndexOf('@');
  if (at < 0) {
    return false;
  }
  const userDomain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return userDomain === domain;
}
